import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AssigneeCandidate, UsersSlice } from "./types";

const initialState: UsersSlice = {
	availableUsers: {}
};

export const {
	name: usersSliceName,
	actions: { setUsers },
	reducer: usersReducer
} = createSlice({
	name: "users",
	initialState,
	reducers: {
		setUsers(
			state: UsersSlice,
			action: PayloadAction<{ readonly fvKey: string; readonly assigneeCandidates: readonly AssigneeCandidate[] }>
		) {
			state.availableUsers[action.payload.fvKey] = action.payload.assigneeCandidates;
		}
	}
});
